import React from "react";
import "./Form.css";

const Form = () => {
  return (
    <div className="form-container">
      <div className="form-info">
        <h2>Save time, save money!</h2>
        <p className="text-input">
          Sign up and we'll send the best deals to yoy
        </p>
        <div className="input-info">
          <input
            className="input-box"
            type="text"
            placeholder="Your Email"
          ></input>
          <button className="input-button">Subscribe</button>
        </div>
      </div>
    </div>
  );
};

export default Form;
